import { GraphQLList, GraphQLNonNull } from 'graphql'
import { ContrastGraphQLFieldConfig } from '../index'
import { Context } from '../shared'
import { ContrastQueryParameters } from '../endpoint-helpers'
import {
  attackEventNotesQueryArgs,
  AttackEventNotesQueryArgs
} from '../types/attack-event-note-query-args'
import {
  AttackEventNote,
  attackEventNoteType
} from '../types/attack-event-note'
import he from 'he'

function normalizeNote(note): AttackEventNote {
  return {
    id: note.id,
    uuid: note.uuid,
    note: he.decode(note.note),
    creationTime: note.creation,
    lastModifiedTime: note.lastModification,
    createdByUserUuid: note.creator_uid,
    createdByUserName: note.creator,
    createdByUserAvatarUrl: note.creator_avatar_url,
    lastUpdatedByUserName: note.lastUpdater
  }
}

export const attackEventNotes: ContrastGraphQLFieldConfig<
  any,
  Context,
  AttackEventNotesQueryArgs,
  AttackEventNote[]
> = {
  description: 'Get attack event notes for an attack event UUID.',
  type: new GraphQLNonNull(
    new GraphQLList(new GraphQLNonNull(attackEventNoteType))
  ),
  args: attackEventNotesQueryArgs,
  async resolve(_source, args, context) {
    const { organizationId, attackEventUuid } = args
    const { connector } = context

    const params = new ContrastQueryParameters()
    params.append('expand', 'avatarUrl')

    const { notes = [] } = await connector.get(
      `/${organizationId}/rasp/events/notes/${attackEventUuid}/?${params}`
    )
    return notes.map(normalizeNote)
  }
}
